import React from "react";
//#region types
import { TodoCardProps } from "models/propTypes/todoPropTypes";
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { Currency } from "translations/translationKeys";
import { MissingDocumentEnums } from "models/enums";
import { FormHandles } from "models/propTypes/genericFormProps";
import { UploadedFile } from "models/utilTypes/fileUtilsTypes";
//endregion
//#region components
import TopTodoCard from "../../_partials/topTodoCard";
import { FileViewerContainer, GenericCommentsView, TitledContainerInner, EntityCardContent } from "components/common";
import {
  BankInformationPanel,
  MissingDocumentFooter,
  MissingDocumentTodoSelectionFormContainer,
  useMissingDocumentSnoozeAction,
} from "components/missingDocument";
import { useMissingDocumentService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const MissingDocumentTodo: React.FC<TodoCardProps> = (props) => {
  const missingDocumentService = useMissingDocumentService();

  const missingDocument = props.item.missingDocument ?? ({} as WintSuperkollAPIModel.MissingDocument);
  const formRef = React.useRef<FormHandles>(null);
  const snoozeAction = useMissingDocumentSnoozeAction(missingDocument!.id, props.onActionSuccess);

  const [attachments, setAttachments] = React.useState<UploadedFile[]>();
  const [oldAttachments, setOldAttachments] = React.useState<UploadedFile[]>([]);

  const submitForm = () => {
    return (formRef.current && formRef.current.submit()) || new Promise<void>((resolve) => resolve());
  };
  React.useEffect(() => {
    if (!missingDocument?.id) return;

    if (missingDocument?.attachments) {
      Promise.all(
        missingDocument.attachments.map((attachment) => {
          return missingDocumentService.getAttachment(missingDocument!.id, attachment.id).then(
            (val): UploadedFile => ({
              id: attachment.id,
              contentType: attachment.contentType ?? "",
              data: val,
              fileName: attachment.fileName ?? "",
            })
          );
        })
      ).then((files) => {
        setOldAttachments(files ?? []);
      });
    } else {
      setOldAttachments([]);
    }
  }, [missingDocument]);

  const onFilesUploadChange = (updatedValue: UploadedFile[]) => setAttachments(updatedValue);

  const amountType =
    missingDocumentService.getAmountType(missingDocument!.amount) === MissingDocumentEnums.AmountType.Income
      ? LocalizationHelperInstance.getFormattedMessage(TranslationKeys.MissingDocument.Income)
      : LocalizationHelperInstance.getFormattedMessage(TranslationKeys.MissingDocument.Expense);

  const fileViewerComponent = attachments?.length ? (
    <FileViewerContainer
      meta={(attachments ?? []).map((file) => ({ ...file, id: file.id ?? 0, numberOfPages: 1 }))}
      loading={attachments === undefined}
    />
  ) : undefined;

  return (
    <EntityCardContent
      topTodoCard={
        <TopTodoCard
          item={props.item}
          noDescriptionTextWrap
          descriptionHeadingOne={`${amountType}: ${missingDocument?.amount.toString()} ${Currency.SEK}`}
          descriptionHeadingTwo={missingDocument?.text}
          descriptionheadingThree={`${LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.MissingDocument.Account
          )}: ${missingDocument?.accountName?.toString()}`}
          footerText={LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.Common.TransactionDateFormatter,
            " ",
            {
              date: LocalizationHelperInstance.getFormattedDate(
                missingDocument?.date ? missingDocument?.date.toString() : ""
              ),
            }
          )}
          quickActions={[snoozeAction]}
        />
      }
      todoMainSection={
        <TitledContainerInner
          header={
            missingDocument.isSentBack
              ? LocalizationHelperInstance.getFormattedMessage(TranslationKeys.MissingDocument.SentBack)
              : LocalizationHelperInstance.getFormattedMessage(TranslationKeys.MissingDocument.ReasonForPayment, "", {
                  amountType: amountType.toLowerCase(),
                })
          }
          subHeader={
            missingDocument.isSentBack
              ? LocalizationHelperInstance.getFormattedMessage(TranslationKeys.MissingDocument.SentBackDescription)
              : LocalizationHelperInstance.getFormattedMessage(
                  TranslationKeys.MissingDocument.ReasonForPaymentDescription,
                  "",
                  {
                    amountType: amountType.toLowerCase(),
                    accountName: missingDocument?.accountName?.toString() || "",
                  }
                )
          }
        >
          <BankInformationPanel missingDocument={missingDocument} />
          <MissingDocumentTodoSelectionFormContainer
            ref={formRef}
            parentId={missingDocument.id}
            missingDocument={missingDocument}
            oldAttachments={oldAttachments}
            onFilesUploadChange={onFilesUploadChange}
            fileViewer={fileViewerComponent}
          />
        </TitledContainerInner>
      }
      infoViewer={fileViewerComponent}
      footer={
        <MissingDocumentFooter
          missingDocument={missingDocument!}
          reloadHandler={props.onActionSuccess}
          onMissingDocumentAccept={submitForm}
          disableSuccessMessages
        />
      }
    >
      <GenericCommentsView
        parentId={missingDocument!.id}
        type={WintSuperkollAPIModel.GenericCommentType.MissingDocument}
        collapsed
      />
    </EntityCardContent>
  );
};

export default MissingDocumentTodo;
